// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotificationIconHeader_wrapper__YYMmW","iconActive":"NotificationIconHeader_iconActive__Z1q7W"};